import { bl_fi_my_einvoice_request_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoicePortalRequestHdrContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_request_hdr: bl_fi_my_einvoice_request_hdr_RowClass = new bl_fi_my_einvoice_request_hdr_RowClass();
}
